import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, ButtonToolbar, Button, Panel, Schema } from "rsuite";
import { useDispatch } from "react-redux";
import {
  ForgotPasswordAsync,
  RecoverPasswordAsync,
  VerifyOTPAsync,
} from "../redux/slice/loginSlice";
import {
  UserToken,
  getUserProfile,
  toastError,
  toastSuccess,
} from "../utils/helper";
import PasswordChecklist from "react-password-checklist";
import { CryptoJSDecrypt, CryptoJSEncrypt } from "../utils/encryption";

const Modified_By = "ime_online_portal";
const phoneRegExp = /^[6-9]\d{9}$/;

export default function ForgetPassoword() {
  const formRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [mobileNumber, setMobileNumber] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp, setOTP] = useState("");
  const [step, setStep] = useState(1);

  const { StringType, NumberType } = Schema.Types;
  const model = Schema.Model({
    MobileNo: StringType()
      .isRequired("This field is required.")
      .pattern(phoneRegExp, "Enter valid Phone number"),
  });

  const otpRegex = /^(?=.{6}$)[A-Z0-9]{4,6}\s*$/;
  const model2 = Schema.Model({
    OTP: NumberType()
      .pattern(otpRegex, "Enter valid OTP")
      .isRequired("This field is required."),
  });

  const model3 = Schema.Model({
    Password: StringType().isRequired("This field is required."),
    confirmPassword: StringType()
      .addRule((value) => {
        if (value !== newPassword) {
          return false;
        }

        return true;
      }, "The two passwords do not match")
      .isRequired("This field is required."),
  });

  const handleOTP = async () => {
    if (!formRef.current.check()) {
      console.error("Form Error");
      return;
    }
    setLoading(true);
    // await UserToken();
    const formData = {
      MobileNo: mobileNumber,
      CreatedBy: Modified_By,
    };
    const response = await dispatch(
      ForgotPasswordAsync({
        EncString: CryptoJSEncrypt(JSON.stringify(formData)),
      })
    );
    const res = JSON.parse(CryptoJSDecrypt(response.payload));
    if (ForgotPasswordAsync.fulfilled.match(response)) {
      if (res.Code === "101") {
        toastError(res.Message);
        setLoading(false);
        return;
      }
      setLoading(false);
      setStep(2);
    }
  };

  const handleVerifyOTP = async () => {
    if (!formRef.current.check()) {
      console.error("Form Error");
      return;
    }
    setLoading(true);
    const formData = {
      MobileNo: mobileNumber,
      OTP: otp,
      ModifiedBy: Modified_By,
    };
    const response = await dispatch(
      VerifyOTPAsync({
        EncString: CryptoJSEncrypt(JSON.stringify(formData)),
      })
    );


    const res = JSON.parse(CryptoJSDecrypt(response.payload));
    if (VerifyOTPAsync.fulfilled.match(response)) {
      if (res.Code === "101") {
        setLoading(false);
        toastError(res.Message);
        return;
      }
      setLoading(false);
      setStep(3);
    }
  };

  const changePassword = async () => {
    if (!formRef.current.check()) {
      console.error("Form Error");
      return;
    }
    setLoading(true);
    const formData = {
      MobileNo: mobileNumber,
      OTP: otp,
      Password: newPassword,
      ModifiedBy: Modified_By,
    };
    const response = await dispatch(
      RecoverPasswordAsync({
        EncString: CryptoJSEncrypt(JSON.stringify(formData)),
      })
    );
    const res = JSON.parse(CryptoJSDecrypt(response.payload));
    if (RecoverPasswordAsync.fulfilled.match(response)) {
      if (res.Code === "101") {
        setLoading(false);
        toastError(res.Message);
        return;
      }
      setLoading(false);
      toastSuccess(res.message);
      navigate("/login");
    }
  };

  return (
    <section className="p-5 grid min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 h-full">
        <div className="">
          <div
            className="shadow rounded-xl p-5 h-full"
            style={{ backgroundColor: "#efeff2" }}
          >
            <div className="container mx-auto relative h-full flex justify-center items-center">
              <img
                src="/Products/prod_1_transparent.png"
                alt="tli"
                className="w-full"
              />
              {/* <img src="/Products/1000000.jpg" alt="tli" className="w-full" /> */}
              <p className="text-center absolute inset-x-0 bottom-0">
                <small>
                  IME Life Insurance © Copyright 2025. All rights
                  reserved.
                </small>
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center h-full">
          <div className="mr-auto login-wrapper">
            <img
              src="/images/logo.png"
              alt="business man"
              className="mx-auto"
              width={250}
              height={100}
            />
            <Panel
              header={<h1 className="font-bold text-xl">Recover Passoword</h1>}
              className="w-full my-5"
            >
              {step === 1 && (
                <Form fluid ref={formRef} model={model}>
                  <Form.Group onChange={(e) => setMobileNumber(e.target.value)}>
                    <Form.ControlLabel>Mobile No</Form.ControlLabel>
                    <Form.Control name="MobileNo" />
                  </Form.Group>
                  <Form.Group>
                    <ButtonToolbar>
                      <Button
                        appearance="primary"
                        className="btn-primary"
                        onClick={handleOTP}
                        loading={loading}
                      >
                        Send OTP
                      </Button>
                    </ButtonToolbar>
                  </Form.Group>
                </Form>
              )}
              {step === 2 && (
                <Form fluid ref={formRef} model={model2}>
                  <Form.Group onChange={(e) => setOTP(e.target.value)}>
                    <Form.ControlLabel>OTP</Form.ControlLabel>
                    <Form.Control type="number" name="OTP" />
                  </Form.Group>
                  <Form.Group>
                    <ButtonToolbar>
                      <Button
                        appearance="primary"
                        className="btn-primary"
                        onClick={handleVerifyOTP}
                        loading={loading}
                      >
                        Verify OTP
                      </Button>
                    </ButtonToolbar>
                  </Form.Group>
                </Form>
              )}
              {step === 3 && (
                <Form fluid ref={formRef} model={model3}>
                  <Form.Group onChange={(e) => setNewPassword(e.target.value)}>
                    <Form.ControlLabel>New Password</Form.ControlLabel>
                    <Form.Control type="password" name="Password" />
                  </Form.Group>
                  <Form.Group
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  >
                    <Form.ControlLabel>Confirm Password</Form.ControlLabel>
                    <Form.Control type="password" name="confirmPassword" />
                  </Form.Group>
                  <div className="mb-4">
                    <PasswordChecklist
                      rules={[
                        "minLength",
                        "specialChar",
                        "number",
                        "capital",
                        "lowercase",
                      ]}
                      minLength={6}
                      value={newPassword}
                      onChange={(isValid) => {
                        setisPasswordValid(isValid);
                      }}
                      messages={{
                        minLength: "Password must have at least 6 characters.",
                        lowercase:
                          "Password must have a small letter (a, b, b)",
                        capital:
                          "Password must have a capital letter (A, B, C).",
                        specialChar:
                          "Password must have special characters (@, $, #).",
                        number: "Password must have a number (1, 2, 3).",
                      }}
                    />
                  </div>
                  <Form.Group>
                    <ButtonToolbar>
                      <Button
                        appearance="primary"
                        className="btn-primary"
                        onClick={changePassword}
                        loading={loading}
                      >
                        Submit
                      </Button>
                    </ButtonToolbar>
                  </Form.Group>
                </Form>
              )}
            </Panel>
            <p className="text-center">
              Already have an account?{" "}
              <Link to="/login" className="underline">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
